import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ImageContainer from "@shared/components/contents/imageContainer/ImageContainer";
import Link from "@shared/components/contents/link/Link";
import Icon from "@shared/components/Icon";
import React from "react";
const ProductBlock = (props) => {
    const { id, image, title, subtitle, description, link, ...others } = props;
    return (_jsxs(Stack, { spacing: 3, sx: {
            width: "100%",
            maxWidth: "560px",
            height: "100%",
            border: "1px solid",
            borderColor: "border.grey",
            padding: {
                xs: 2,
                md: 3,
            },
            backgroundColor: "background.paper",
        }, ...others, children: [image && _jsx(ImageContainer, { ratio: 43, children: image }), _jsxs(Stack, { spacing: 1, children: [_jsxs(Stack, { spacing: 2.5, children: [_jsxs(Stack, { direction: "row", spacing: 1, sx: { alignItems: "flex-end" }, children: [title && (_jsx(Typography, { variant: "h4", component: "p", children: title })), subtitle && (_jsx(Typography, { variant: "body1", component: "p", color: "text.secondary", children: subtitle }))] }), _jsx(Box, { children: description })] }), _jsx(Stack, { direction: "row", sx: { justifyContent: "flex-end" }, children: link && (link.page || link.url) && (_jsx(Button, { variant: "text", endIcon: _jsx(Icon, { icon: "arrow-right" }), component: Link, ...link, children: link.title })) })] })] }));
};
export default ProductBlock;
